import React from "react";

/**
 * Top-level error boundary.
 *
 * React 16 unmounts the ENTIRE tree when a render/lifecycle error escapes with
 * no boundary — that is what made a single component crash (e.g. the Google
 * Maps DrawingManager removal in API v3.65) blank the whole portal with no
 * visible error. This boundary contains such crashes to a friendly fallback and
 * keeps the error in the console for diagnostics.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Preserve the real error for DevTools / log scraping.
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught an error:", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: "48px 24px",
            textAlign: "center",
            fontFamily: "Arial, sans-serif",
            color: "#333",
          }}
        >
          <h2 style={{ marginBottom: 8 }}>Something went wrong on this page.</h2>
          <p style={{ marginBottom: 24, color: "#666" }}>
            The page hit an unexpected error. Please reload, or go back and try
            again. If it keeps happening, contact support.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "8px 20px",
              background: "#1E90FF",
              color: "#fff",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
